import React from "react";
import { useLocation } from "react-router-dom";
import SEO from "../../../utiles/seo/SEO";
import siteMetadata from "../../../utiles/seo/siteMetadata";
import Breadcrumb from "../../common/Breadcrumb";
import SubscribArea from "../../common/SubscribArea";
import ServiceWrap from "./ServiceWrap";

function Service() {
  const location = useLocation();
  const currentPath = location.pathname;
  const { title, description, keywords } =
    siteMetadata.paths[currentPath] || siteMetadata.common;

  return (
    <>
      <SEO
        path={currentPath}
        title={title}
        description={description}
        keywords={keywords}
      />
      <div className="digital-shifts-wrap">
        <Breadcrumb pageName="Service" pageTitle="Service" />
        <ServiceWrap />
        <SubscribArea />
      </div>
    </>
  );
}

export default Service;
